<ion-app>
  <app-offline-indicator></app-offline-indicator>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
